import { styled } from "styled-components";

export const ReviewContainer = styled.div`
  width: 100%;
  border: 2.5px solid black;
  display: flex;
  justify-content: start;
  align-items: start;

  flex-direction: column;
`;
